































import { defineClassComponent, useFold } from '@/hooks'
import { JointComponents } from '../../components'
import { jointGoodsModelProvider } from '../model'

export default defineClassComponent(
  {
    components: JointComponents,
  },
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      fold = useFold({
        container: 'container',
        trigger: 'trigger',
        height: 350,
      })
    },
)
